import React, { useEffect } from "react";
import { connect }  from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

// core components
import EditForm from './editForm';

function EditDialog(props) {
    const { gender, closeDialog, isOpen, isSubGender, updated } = props;

    useEffect(() => {
        if (updated) {
            closeDialog();
        }
    }, [updated]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={isSubGender ? "gender.form.sub.update.title" : "gender.form.update.title"} />
            </DialogTitle>
            <DialogContent>
                <EditForm
                    closeDialog={closeDialog}
                    gender={gender}
                    initialValues={gender}
                />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        updated: state.gender.update.updated,
    }
};

export default connect(
    mapStateToProps,
    null,
)(EditDialog);
